Moderation.Views ||= {}

class Moderation.Views.AccountSessionsView extends Backbone.View
  template: JST["backbone/templates/moderation/account_sessions"]
  className: 'account-with-sessions'

  initialize: (@options = {}) ->
    @name = @options.name
    @sessions = @options.sessions
    @current_account = @options.current_account

  render: =>
    @$el.html(@template(@))
    @addSessions()
    return this

  addSessions: ->
    @sortSessions()
    for session in @sessions
      sessionView = new Moderation.Views.ModerationSessionView({ session: session, current_account: @current_account })
      @$el.find('.sessions-table').append(sessionView.render().$el)

  sortSessions: ->
    @sessions = _(@sessions).chain()
    .sortBy (session) ->
      session.name
    .sortBy (session) ->
      parseInt(session.blocked_count) * (-1)
    .sortBy (session) ->
      parseInt(session.enqueued_count)
    .sortBy (session) ->
      parseInt(session.enqueued_count - session.blocked_count)
    .reverse()
    .value()